<script lang="ts">
  export let color: string;
</script>

<style lang="postcss">
  div {
    font-size: 9px;
    font-weight: 600;
    text-transform: uppercase;
    color: white;
    background-color: var(--badge-color, gray);
    box-shadow: 0 4px 4px rgb(0 0 0 / 25%);
    border-radius: 0 8px;
    padding: 4px 8px 5px;
  }
</style>

<div style="--badge-color: {color}">
  <slot />
</div>
